import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaTimes, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';
import { deleteAccount } from '../../Services/User/Profile';
import { showToast } from '../Toast/Toast';
import CustomButton from '../CustomButton';
import './DeleteAccountModal.css';

const DeleteAccountModal = ({ show, onHide }) => {
  const [step, setStep] = useState(1); // 1: Confirmation, 2: Success
  const [deleting, setDeleting] = useState(false);

  const handleConfirm = async () => {
    try {
      setDeleting(true);
      const response = await deleteAccount();
      
      if (response.status) {
        setStep(2);
      } else {
        showToast(response.message || 'Failed to delete account', 'error');
      }
    } catch (error) {
      console.error('Error deleting account:', error);
      showToast(error.message || 'Failed to delete account', 'error');
    } finally {
      setDeleting(false);
    }
  };

  const handleCancel = () => {
    setStep(1);
    onHide();
  };

  const handleSuccessClose = () => {
    setStep(1);
    onHide();
    // Optionally redirect to login or home page
    window.location.href = '/login';
  };

  const renderConfirmationStep = () => (
    <div className="delete-modal-content">
      <div className="delete-icon-wrapper">
        <FaExclamationCircle className="delete-icon" />
      </div>
      <h4 className="delete-modal-title">Delete Account</h4>
      <p className="delete-modal-question">
        Are you sure you want to delete your account? This action cannot be undone.
      </p>
      <div className="delete-modal-buttons">
        <CustomButton
          onClick={handleConfirm}
          disabled={deleting}
          className="delete-yes-btn"
        >
          {deleting ? 'Deleting...' : 'Yes'}
        </CustomButton>
        <CustomButton
          onClick={handleCancel}
          variant="secondary"
          className="secondaryButton"
        >
          No
        </CustomButton>
      </div>
    </div>
  );

  const renderSuccessStep = () => (
    <div className="delete-modal-content">
      <div className="success-icon-wrapper">
        <FaCheckCircle className="success-icon" />
      </div>
      <h4 className="delete-modal-title">Successful</h4>
      <p className="success-message">
        Your account has been deleted successfully!
      </p>
      <div className="delete-form-buttons">
        <CustomButton
          onClick={handleSuccessClose}
          className="delete-ok-btn"
        >
          Ok
        </CustomButton>
      </div>
    </div>
  );

  return (
    <Modal show={show} onHide={handleCancel} centered className="delete-account-modal">
      <Modal.Body className="delete-modal-body">
        <button className="modal-close-btn" onClick={handleCancel}>
          <FaTimes />
        </button>
        
        {step === 1 && renderConfirmationStep()}
        {step === 2 && renderSuccessStep()}
      </Modal.Body>
    </Modal>
  );
};

export default DeleteAccountModal;

